import ApiConfig from "../../../api/api.config";

const apiUrl = `${ApiConfig.getEntryPoint()}files`;

export const getFileUrl = (fileId: number) => `${apiUrl}/${fileId}`;